import { Document, Image, Text, StyleSheet, Page, Font } from "@react-pdf/renderer";
import { FC, useMemo } from "react";
import mentalSolutionCard from "../../../../assets/cards/mental.png";
import physicalSolutionCard from "../../../../assets/cards/physical.png";
import socialSolutionCard from "../../../../assets/cards/social.png";
import emotionalSolutionCard from "../../../../assets/cards/emotional.png";
import diploma from "../../../../assets/diploma/diploma.png";
import roboto from "../../../../assets/fonts/Roboto-Regular.ttf";
import { CardType } from "../../../../util/enums";
import { useTranslation } from "react-i18next";

interface IGamePdf {
	recievedStatistics?: any,
  teamNumber?: number | undefined,
  threeActions?: any
}

const GamePdf: FC<IGamePdf> = ({recievedStatistics, teamNumber, threeActions}) => {
  const { t, i18n } = useTranslation();

  if(i18n.language === 'ch') {
    Font.register({
      family: "ZCool",
      src:
        "https://fonts.gstatic.com/s/zcoolkuaile/v7/tssqApdaRQokwFjFJjvM6h2WpozzoXhC2g.ttf"
    })
  } else {
    Font.register({
      family: "ZCool",
      src:
        roboto
    })
  }

  let myEmail = localStorage["userEmailInCaseHeLogsOut"];

  if (!teamNumber)
    teamNumber = 0;

  let solutionStatisticsForTheCurrentUser = recievedStatistics.solutionStatisticPerPlayer.filter( (userStatistics: any) => userStatistics.player.email === myEmail)
  const myUseOfSolutionTypes = useMemo(() => solutionStatisticsForTheCurrentUser?.find((statistic: any) => statistic.player.email === myEmail), [myEmail, solutionStatisticsForTheCurrentUser]);
  const { Mental, Physical, Relations, Emotional} = myUseOfSolutionTypes;

  const statisticsPdfData = {
    userName: localStorage["currentUserFullName"],
    strengths: recievedStatistics.strengthStatistic.strengthCards,
    solutions: recievedStatistics.chosenSolutionCards,
    myUseOfSolutionCardsByType: {
      Emotional: myUseOfSolutionTypes.Emotional,
      Joker:0,
      Mental: myUseOfSolutionTypes.Mental,
      Physical: myUseOfSolutionTypes.Physical,
      Relations: myUseOfSolutionTypes.Relations
    }
  }

  let totalUses = Mental + Physical + Relations + Emotional;

  if (totalUses === 0) 
    totalUses = 0.01;

  let statisticsGraphPosition = {
    mentalCircleWidth: 100,
    mentalCircleShift: 100,
    mentalCircleShiftOposite: 100,
    physicalCircleWidth: 100,
    physicalCircleShift: 100,
    physicalCircleShiftOposite: 100,
    relationsCircleWidth: 100,
    relationsCircleShift: 100,
    relationsCircleShiftOposite: 100,
    emotionalCircleWidth: 100,
    emotionalCircleShift: 100,
    emotionalCircleShiftOposite: 100,
    mentalPercentage:  Math.round(100/totalUses*Mental),
    physicalPercentage:  Math.round(100/totalUses*Physical),
    relationsPercentage:  Math.round(100/totalUses*Relations),
    emotionalPercentage:  Math.round(100/totalUses*Emotional),
  }

  if(totalUses !== 0) {
    
    statisticsGraphPosition.mentalCircleWidth  = 100 + (100/totalUses)*Mental;
    statisticsGraphPosition.physicalCircleWidth = 100 + (100/totalUses)*Physical;
    statisticsGraphPosition.relationsCircleWidth = 100 + (100/totalUses)*Relations;
    statisticsGraphPosition.emotionalCircleWidth  = 100 + (100/totalUses)*Emotional;

    statisticsGraphPosition.mentalCircleShift  = 100 + (100 - (100/totalUses)*Mental)/2;
    statisticsGraphPosition.physicalCircleShift = 100 + (100 - (100/totalUses)*Physical)/2;
    statisticsGraphPosition.relationsCircleShift = 100 + (100 - (100/totalUses)*Relations)/2;
    statisticsGraphPosition.emotionalCircleShift  = 100 + (100 - (100/totalUses)*Emotional)/2;

    statisticsGraphPosition.mentalCircleShiftOposite  = 100 - (100 - (100/totalUses)*Mental)/2;
    statisticsGraphPosition.physicalCircleShiftOposite = 100 - (100 - (100/totalUses)*Physical)/2;
    statisticsGraphPosition.relationsCircleShiftOposite = 100 - (100 - (100/totalUses)*Relations)/2;
    statisticsGraphPosition.emotionalCircleShiftOposite  = 100 - (100 - (100/totalUses)*Emotional)/2;
  }

  const getSolutionImage = (card: any) => {
    switch(card.type) {
      case CardType.MENTAL_SOLUTION: return mentalSolutionCard ; 
      case CardType.PHYSICAL_SOLUTION: return physicalSolutionCard ; 
      case CardType.SOCIAL_SOLUTION: return socialSolutionCard; 
      case CardType.EMOTIONAL_SOLUTION: return emotionalSolutionCard; 
      default: return mentalSolutionCard;
    }
  }

	const styles = StyleSheet.create({
        body: {
          paddingTop: 35,
          paddingBottom: 65,
          paddingHorizontal: 35,
          backgroundColor: "#005776",
          fontFamily: "ZCool"
        },
        rotateBody: {
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          top: 20,
          right: 20,
          width: 800,
          height: 510,
        },
        borderAround: {
          position: "absolute", 
          top: 0, 
          left: 0,
          width: 800,
          height: 560,
          borderRadius: 25,
          border: "2 solid darkgray",
        },
        row: {
          display: "flex",
          flexDirection: "column",
          width: "60%",
          height: "100%",
          top: 10,
        },
       rightRow: {
          display: "flex",
          flexDirection: "column",
          width: "40%",
          height: "100%",
          top: 10,
        },
        strengthTable: {
          borderRadius: 20,
          margin: "0 10%",
          fontSize: 10,
          overflow: "hidden"
        },
          strengthTableRow: {
          display: "flex",
          flexDirection: "row",
        },
        strengthTableRowTitleOne: {
          width: "25%",
          backgroundColor: "#002D3C",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "6 6 6 6",
        },
        strengthTableRowTitleTwo: {
          width: "25%",
          backgroundColor: "#FF00A7",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "6 6 6 6",
        },
        strengthTableRowTitleThree: {
          width: "25%",
          backgroundColor: "#53BD8B",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "6 6 6 6",
        },
        strengthTableRowTitleFour: {
          width: "25%",
          backgroundColor: "#40C2CD",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "6 6 6 6",
        },
        strengthTableRowTitleFive: {
          width: "25%",
          backgroundColor: "#FED100",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "6 6 6 6",
        },
        strengthTableRowDescription: {
          width: "75%",
          padding: "5 2%",
          backgroundColor: "#E5EDF1",
          color: "#005776",
        },
        strengthTableRowDescriptionDark: {
          width: "75%",
          padding: "5 2%",
          backgroundColor: "#D3E2E8",
          color: "#005776",
        },
          
        title: {
          fontSize: 14,
          margin: "10 0 20 0",
          color: "#fff",
          textAlign: "center",
          fontFamily: "ZCool"
        },
          solutionWrapper: {
          display: "flex",
          justifyContent: "space-around",
          flexDirection: "row",
        },
        solutionImage: {
          position: "relative",
          width: 130,
          height: "auto",
          paddgin: "0 2"
        },
        solutionImageSvg: {
          width: 130,
          height: "auto",
        },
        solutionText: {
          fontSize: 10,
          width: "100%",
          top: 62,
          bottom: 50,
          display: "flex",
          justifyContent: "center",
          color: '#005776',
          padding: '0 14',
          textAlign: "center",
          position: "absolute",
          fontWeight: 900,
          fontFamily: "ZCool"
        },
        solutionDescription: {
          width: "100%",
          top: 86,
          display: "flex",
          justifyContent: "center",
          color: '#005776',
          textAlign: "center",
          position: "absolute",
          padding: '0 14',
          fontWeight: 900,
          fontSize: 7,
          fontFamily: "ZCool"
        },
          solutionInfoTextWrapper: {
          position: "relative",
          top: 10,
          border: "1px solid white",
          backgroundColor: "white",
          borderRadius: 15,
        },
          solutionInfoNotch: {
          position: "relative",
          left: 60,
          bottom: 5,
          backgroundColor: "white",
          width: 10,
          height: 10,
          transform: "rotate(45deg)",
        },
        solutionInfoText: {
          width: "100%",
          display: "flex",
          justifyContent: "center",
          color: '#005776',
          textAlign: "center",
          padding: '0 12',
          fontWeight: 900,
          fontSize: 7,
          marginBottom: 6,
          fontFamily: "ZCool"
        },
        tedTalkUrl: {
          position: "relative",
          top: 15,
          width: "100%",
          textAlign: "center",
          color: "white",
          textDecoration: "underline",
          fontSize: 9
        },
        tedTalkLogo: {
          position: "relative",
          width: "100%",
          padding: "0, 40",
          textAlign: "center",
          top: 5,
        },
      
      
        actionPart: {
          position: "relative",
          top: 190,
        },
          actionText: {
          color: "white",
          fontSize: 10,
          width: "100%",
          padding: "5%",
          fontFamily: "ZCool"     
        },
      
          zoomIt: {
          position: "relative",
          bottom: 100,
          right: 50
        }, 
        displayInRow: {
          width: 500,
          left: 20,
          height: 105,
          display: "flex",
          flexDirection: "row",
        },
        decorationLine: {
          position: "absolute",
          left: 230,
          top: -18,
          width: 5,
          height: "auto",
          transform: "rotate(90deg)",
        },
        rightDecorationLine: {
          position: "absolute",
          left: 155,
          top: -18,
          width: 5,
          height: "auto",
          transform: "rotate(90deg)",
        },
        bodyx: {
            paddingTop: 5,
            backgroundColor: "#005776",
            fontFamily: "ZCool"
        },
        rotate: {
            transform: 'rotate(90)',
            left: 285,
            top: 250
        },
        diplomaImage: {
            position: 'absolute',
            width: 845
        },
        userFullNameWrapper: {
            position: 'absolute',
            width: 280,
            height: 80,
            top: 240,
            left: 270,
        },
        userFullName: {
            position: 'relative',
            width: 300,
            margin: 'auto',
            color: '#53BD8B',
            textAlign: 'center',
            fontSize: 26
        },
        summaryWrapper: {
            position: 'absolute',
            width: 600,
            height: 400,
            top: 80,
            left: 100,
            padding: '40 50 0 50',
        },
        
      
        smallFlex: {
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: 400,
        },
      
        
        smallSquare: {
          position: "relative",
          width: 200,
          height: 200,
          overflow: "hidden",
        },
          circleTopLeft: {
          width: statisticsGraphPosition.mentalCircleWidth,
          height: statisticsGraphPosition.mentalCircleWidth,
          borderRadius: "50%",
          backgroundColor: "#3AC0CA",
          position: "relative",
          left: statisticsGraphPosition.mentalCircleShift,
          top: statisticsGraphPosition.mentalCircleShift,
        },
        circleTopRight: {
          width: statisticsGraphPosition.physicalCircleWidth,
          height: statisticsGraphPosition.physicalCircleWidth,
          borderRadius: "50%",
          backgroundColor: "#53BD8B",
          position: "relative",
          right: statisticsGraphPosition.physicalCircleShiftOposite,
          top: statisticsGraphPosition.physicalCircleShift,
        },
        circleBottomLeft: {
          width:  statisticsGraphPosition.relationsCircleWidth,
          height:  statisticsGraphPosition.relationsCircleWidth,
          borderRadius: "50%",
          backgroundColor: "#FED100",
          position: "relative",
          left: statisticsGraphPosition.relationsCircleShift,
          bottom: statisticsGraphPosition.relationsCircleShiftOposite,
        },
        circleBottomRight: {
          width:  statisticsGraphPosition.emotionalCircleWidth,
          height:  statisticsGraphPosition.emotionalCircleWidth,
          borderRadius: "50%",
          backgroundColor: "#FF00A7",
          position: "relative",
          right: statisticsGraphPosition.emotionalCircleShiftOposite,
          bottom: statisticsGraphPosition.emotionalCircleShiftOposite
        },
      
      
          bigFlex: {
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: 400,
        },
        smallCircleTopLeft: {
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: "#1690B2",
          position: "relative",
          left: 150,
          top: 150,
        },
        smallCircleTopRight: {
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: "#1AA086",
          position: "relative",
          right: 50,
          top: 150,
        },
        smallCircleBottomLeft: {
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: "#FA8003",
          position: "relative",
          left: 150,
          bottom: 50,
        },
        smallCircleBottomRight: {
          width: 100,
          height: 100,
          borderRadius: "50%",
          backgroundColor: "#BF0072",
          position: "relative",
          right: 50,
          bottom: 50,
        },
      
        pictureFlex: {
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: 400,
        },
        pictureSquare: {
          position: "relative",
          width: 200,
          height: 200,
        },
        pictureCircle: {
          width: 80,
          height: 80,
          borderRadius: "50%",
          position: "relative",
          left: 160,
          top: 160,
        },
          
          percentageFlex: {
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: 200,
          top: 100,
          left: 100,
        },
        percentageSquare: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 100,
          height: 100,
        },
        percentageText: {
          color: "#fff",
        },
      
        solutionNameFlex: {
          position: "absolute",
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          width: 400,
        },
        solutionNameSquare: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 200,
          height: 200,
          fontSize: 14,
        },
        solutionNameTopLeft: {
          position: "relative",
          top: 50,
          right: 10,      
          color: "#3AC0CA",
          fontFamily: "ZCool"
        },
        interestingText:{
          color: "#3AC0CA",
          fontSize: 10,
          width: "100%",
          padding: "5%" ,
          fontFamily: "ZCool"
        },
        actionableText:{
          color: "#4ABC88",
          fontSize: 10,
          width: "100%",
          padding: "5%",
          fontFamily: "ZCool"
        },
        meaningfulltext:{
          color: "#EB088D",
          fontSize: 10,
          width: "100%",
          padding: "5%",
          fontFamily: "ZCool"
        },
        solutionNameTopRight: {
          position: "relative",
          top: 50,
          left: 35,      
          color: "#4ABC88",
          fontFamily: "ZCool"
        },
        solutionNameBottomLeft: {
          position: "relative",
          bottom: 70,
          right: 12,      
          color: "#FCD00D",
          fontFamily: "ZCool"
        },
        solutionNameBottomRight: {
          position: "relative",
          bottom: 70,
          left: 36,      
          color: "#EB088D",
          fontFamily: "ZCool"
        },
        solutionNameLineTopLeft: {
          position: "relative",
          top: 50,
          left: 30,
          width: 130,
          backgroundColor: "#fff",
          border: "1 solid white"
        },
          solutionNameLineTopRight: {
          position: "relative",
          top: 50,
          right: 5,
          width: 130,
          backgroundColor: "#fff",
          border: "1 solid white"
        },
          solutionNameLineBottomLeft: {
          position: "relative",
          bottom: 70,
          left: 34,
          width: 130,
          backgroundColor: "#fff",
          border: "1 solid white"
        },
          solutionNameLineBottomRight: {
          position: "relative",
          bottom: 70,
          left: 0,
          width: 130,
          backgroundColor: "#fff",
          border: "1 solid white"
        },
          
          
          separatorLine: {
          position: "absolute",
          left: 470,
          top: 120,
          width: 10,
          height: 300
        },
    
    });


	return (
		<Document>
    <Page style={styles.bodyx} orientation="landscape">
     
        <div>
            <Image
                style={styles.diplomaImage}
                src={diploma}
            />

            <div style={styles.userFullNameWrapper}>
                <Text style={styles.userFullName}> {statisticsPdfData.userName} </Text>
            </div>
        </div>
   
    </Page>
    <Page style={styles.body} orientation="landscape">
      
      <div style={styles.rotateBody}>
         <div style={styles.borderAround}></div>
         <div style={styles.row}>
            
            <Text style={styles.title}>{t("yourStrengthCardsText")}</Text>
            
            <Image style={styles.decorationLine} src="https://i.postimg.cc/fTFY2TXn/XMLID-1195.png" />
            
            <div style={styles.strengthTable}>
              <div style={styles.strengthTableRow}>
                <div style={styles.strengthTableRowTitleOne} >
                  <Text> {statisticsPdfData.strengths[0].description.trim()} </Text>
              	</div>
                <div style={styles.strengthTableRowDescription}>
                  <Text> {statisticsPdfData.strengths[0].information.trim()} </Text>
              	</div>
              </div>
              <div style={styles.strengthTableRow}>
                <div style={styles.strengthTableRowTitleTwo}>
                  <Text> {statisticsPdfData.strengths[1].description.trim()} </Text>
              	</div>
                <div style={styles.strengthTableRowDescriptionDark}>
                  <Text> {statisticsPdfData.strengths[1].information.trim()} </Text>
              	</div>
              </div>
              <div style={styles.strengthTableRow}>
                <div style={styles.strengthTableRowTitleThree}>
                  <Text> {statisticsPdfData.strengths[2].description.trim()} </Text>
              	</div>
                <div style={styles.strengthTableRowDescription}>
                  <Text> {statisticsPdfData.strengths[2].information.trim()} </Text>
              	</div>
              </div>
              <div style={styles.strengthTableRow}>
                <div style={styles.strengthTableRowTitleFour}>
                  <Text> {statisticsPdfData.strengths[3].description.trim()} </Text>
              	</div>
                <div style={styles.strengthTableRowDescriptionDark}>
                  <Text> {statisticsPdfData.strengths[3].information.trim()} </Text>
              	</div>
              </div>
              <div style={styles.strengthTableRow}>
                <div style={styles.strengthTableRowTitleFive}>
                  <Text> {statisticsPdfData.strengths[4].description.trim()} </Text>
              	</div>
                <div style={styles.strengthTableRowDescription}>
                  <Text> {statisticsPdfData.strengths[4].information.trim()} </Text>
              	</div>
              </div>
              
          </div>
           
           <Image style={styles.separatorLine} src="https://i.postimg.cc/tgggqz30/2022-02-25-02h04-56.png" />
           
         <div>
          {
            statisticsPdfData.solutions.length != 0 && 
            <Text style={styles.title}>{t("theSolutionCardsYouChose")}</Text>
          }
          <Image style={styles.decorationLine} src="https://i.postimg.cc/fTFY2TXn/XMLID-1195.png" />

           <div style={styles.solutionWrapper} >

            {statisticsPdfData.solutions.map( (solutionCard: any, index: number) => {
              if(index > 3)
                return (<div></div>);

              return (
                <div style={styles.solutionImage} key={index}>
                    <Image  style={styles.solutionImageSvg} src={getSolutionImage(solutionCard)} />
                    <Text style={styles.solutionText}> {solutionCard.title} </Text>
                    <Text style={styles.solutionDescription}> {solutionCard.description} </Text>
                    <div style={styles.solutionInfoTextWrapper}>
                      <div style={styles.solutionInfoNotch}></div>
                      <Text style={styles.solutionInfoText}> {solutionCard.info} </Text>
                    </div>
                    {false && <Text style={styles.tedTalkUrl}> {t("tedTalkTitle")} </Text>}
                    {false && <Image style={styles.tedTalkLogo} src="https://i.postimg.cc/sXJQ93PW/2022-02-24-00h46-18.png" />}
                </div>
              )
            })}
            
           </div>

        </div>
      </div>

        <div style={styles.rightRow}>
          <div>

              <Text style={styles.title}> {t("choosenSolutionCardsYouProposedText")} </Text>
              <Image style={styles.rightDecorationLine} src="https://i.postimg.cc/fTFY2TXn/XMLID-1195.png" />

              <div style={styles.zoomIt}>
                
                <div style={styles.solutionNameFlex}>
          
                    <div  style={styles.solutionNameSquare}>
                        <Text style={styles.solutionNameTopLeft}> {t("mentalText")} </Text>
                        <div  style={styles.solutionNameLineTopLeft}></div>
                    </div>
                    <div  style={styles.solutionNameSquare}>
                      <Text style={styles.solutionNameTopRight}> {t("physicalText")} </Text>
                      <div  style={styles.solutionNameLineTopRight}></div>
                    </div>
                    <div  style={styles.solutionNameSquare}>
                      <Text style={styles.solutionNameBottomLeft}> {t("socialText")} </Text>
                      <div  style={styles.solutionNameLineBottomLeft}></div>
                    </div>
                    <div  style={styles.solutionNameSquare}>
                      <Text style={styles.solutionNameBottomRight}> {t("emotionalText")} </Text>
                      <div  style={styles.solutionNameLineBottomRight}></div>
                    </div>

                </div>
                
            	<div style={styles.bigFlex}>

                  <div  style={styles.smallSquare}>
                    <div style={styles.circleTopLeft}></div>
                  </div>
                  <div  style={styles.smallSquare}>
                    <div style={styles.circleTopRight}></div>
                  </div>
                  <div  style={styles.smallSquare}>
                    <div style={styles.circleBottomLeft}></div>
                  </div>
                  <div  style={styles.smallSquare}>
                    <div style={styles.circleBottomRight}></div>
                  </div>

                </div>

                <div style={styles.smallFlex}>

                    <div  style={styles.smallSquare}>
                      <div style={styles.smallCircleTopLeft}></div>
                    </div>
                    <div  style={styles.smallSquare}>
                      <div style={styles.smallCircleTopRight}></div>
                    </div>
                    <div  style={styles.smallSquare}>
                      <div style={styles.smallCircleBottomLeft}></div>
                    </div>
                    <div  style={styles.smallSquare}>
                      <div style={styles.smallCircleBottomRight}></div>
                    </div>

                </div>

                <div style={styles.percentageFlex}>
          
                    <div  style={styles.percentageSquare}>
                        <Text style={styles.percentageText}> {statisticsGraphPosition.mentalPercentage}% </Text>
                    </div>
                    <div  style={styles.percentageSquare}>
                      <Text style={styles.percentageText}> {statisticsGraphPosition.physicalPercentage}% </Text>
                    </div>
                    <div  style={styles.percentageSquare}>
                      <Text style={styles.percentageText}> {statisticsGraphPosition.relationsPercentage}% </Text>
                    </div>
                    <div  style={styles.percentageSquare}>
                      <Text style={styles.percentageText}> {statisticsGraphPosition.emotionalPercentage}% </Text>
                    </div>

                </div>

                <div style={styles.pictureFlex}>
                    <div  style={styles.pictureSquare}>
                        {/* <Image style={styles.pictureCircle} src={`${process.env.REACT_APP_BACKEND_URL}images/${myEmail}.png`} /> */}
                        <Image style={styles.pictureCircle} src={`https://i.postimg.cc/zfRhDqxc/PersonA.png`} />
                    </div>                                          
                </div>
              </div>

            </div>
            <div style={styles.actionPart}>

              <Text style={styles.title}> {t("iAmText")} </Text>
              <Image style={styles.rightDecorationLine} src="https://i.postimg.cc/fTFY2TXn/XMLID-1195.png" />

              <Text style={styles.title}> {t("whatDoYouTakeAwayFromTheGameText")} </Text>
               {threeActions?.first != "" && <Text style={styles.interestingText}>{t("interestingText")} <Text style={styles.actionText}> {threeActions.first} </Text> </Text>}
               {threeActions?.second != "" && <Text style={styles.actionableText}>{t("actionableText")} <Text style={styles.actionText}> {threeActions.second} </Text> </Text>}
               {threeActions?.third != "" && <Text style={styles.meaningfulltext}>{t("meaningfulText")} <Text style={styles.actionText}> {threeActions.third} </Text> </Text>}

            </div>
          </div>
        
      </div>
      
    </Page>
  </Document>
	);
};

export default GamePdf;